import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import DataTable from "react-data-table-component";
import Hdashboard from "../../../components/Hdashboard";
import JqueryLoad from "../../../JqueryLoad/JqueryLoad";
import { all_notifications_listing } from "../../../api/apiHandler";
import customStyles from "../../../utils/dataTableStyles";

export default function AllNotifications({ isLoader }) {
    const [data, setData] = useState([]);
    const navigate = useNavigate();

    const fetchNotifications = () => {
        isLoader(true);

        all_notifications_listing()
            .then((response) => {
                if (response && response.code === "1") {
                    const dataWithRowCount = response.data.map((row, index) => ({
                        ...row,
                        count: index + 1,
                    }));

                    setData(dataWithRowCount);
                } else {
                    setData([]);
                }

                isLoader(false);
            })
            .catch((err) => {
                console.error(err);
                setData([]);
                isLoader(false);
            });
    };

    useEffect(() => {
        fetchNotifications();
    }, []);

    const columns = [
        {
            name: "No",
            selector: (row) => row.count,
            sortable: false,
            width: "80px",
            center: true,
        },
        {
            name: "User Name",
            selector: (row) => row.full_name || "-",
            sortable: true,
            minWidth: "200px",
            grow: 1,
        },
        {
            name: "Title",
            selector: (row) => row.title || "-",
            sortable: true,
            minWidth: "250px",
            grow: 1,
            wrap: true,
        },
        {
            name: "Message",
            selector: (row) => row.message || "-",
            sortable: true,
            minWidth: "400px",
            grow: 3,
            wrap: true,
            cell: (row) => (
                <div
                    style={{
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        padding: "10px 0",
                        lineHeight: "1.4",
                    }}
                >
                    {row.message || "-"}
                </div>
            ),
        },
    ];

    return (
        <>
            <JqueryLoad />
            <Hdashboard />

            <main>
                <div className="dashboard-app d-lg-flex">
                    <header className="dashboard-toolbar d-lg-flex justify-content-between">
                        <div className="align-items-center justify-content-between d-flex">
                            <div className="d-flex align-items-center">
                                <a className="menu-toggle align-items-center d-lg-none d-flex">
                                    <i className="fa fa-bars" />
                                </a>

                                <a
                                    href="index.php"
                                    className="d-lg-none d-block brand-logo"
                                >
                                    <img
                                        src="./assets/images/logo.png"
                                        alt="logo"
                                    />
                                </a>
                            </div>
                        </div>
                    </header>

                    <div className="w-100">
                        <div className="d-flex justify-content-between align-items-center title mb-2 mt-4 ms-4 me-4">
                            <p className="fs-3 fw-500 mb-0">
                                Notifications Sent
                            </p>

                            <button
                                onClick={() => navigate("/messages")}
                                className="btn-theme bg-yellow"
                            >
                                Send Message
                            </button>
                        </div>

                        <div
                            className="px-4 mt-3"
                            style={{
                                width: "100%",
                                overflowX: "auto",
                            }}
                        >
                            {data.length === 0 ? (
                                <p className="text-center text-purple fw-500 fs-3 mt-5">
                                    No Data Found
                                </p>
                            ) : (
                                <DataTable
                                    columns={columns}
                                    data={data}
                                    pagination
                                    persistTableHead
                                    responsive
                                    highlightOnHover
                                    striped
                                    customStyles={customStyles}
                                    className="custom-data-table"
                                />
                            )}
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
}